import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from "@fortawesome/free-solid-svg-icons";
import MapContent from "../map/MapContent";
import { ProductComponent } from "../products/ProductComponent";
import { getApp } from "../../service/mftc-api";

import TemplateInput from "./TemplateInput";
import { FlatObject, RecomposeContent } from "../../tools/tpl";
import { data } from "../../service/data";
import { closeModal, showModal } from "../modal";
import { runAction, runActionSync } from "../../tools/actions";
import { metaStructureMapping } from "../../tools/meta";
import Icon from "../Icon";
import { useFetcher, useLocation } from "react-router-dom";
import { setStructureCss } from "../../tools/mediacss";
import Svg from "../Svg";

//import { MfctContext } from "../../context";
const _components = { ProductComponent: ProductComponent };

const TemplateX = React.memo(
  ({
    //function TemplateX({
    label,
    template,
    internals,
    setInternal,
    palette,
    _internalContent,
    content,
    templates,
    schemas,
    contents,
    id,
    selectTpl,
    selected,
    safeDisplay,
    parentClick,
    schema_prop,
    snapAlign,
    isFirst,
    navigate,
    self,
    setLocalContent,
    suid_path,
    tpl_id,
  }) => {
    if (!content) content = {};

    if (isFirst) console.log("display Template X first ", isFirst);
    if (!window.content) window.content = {};
    window.content[id] = content;
    if (!window.structure) window.structure = {};
    window.structure[id] = template;
    const ref = useRef();
    //const {project} = useContext(MfctContext)

    const [transitionState, setTransitionState] = useState(
      !template.condition ? "" : "Unknown"
    );
    const location = useLocation();
    const [internalContent, setInternalContent] = useState({});
    const [popupTemplate, setPopupTemplate] = useState();

    const [isAnimating, setIsAnimating] = useState(false); // Pour gérer le début des transitions
    const [isVisible, setIsVisible] = useState(false); // Gère si le composant doit être visible ou caché

    // Calculer les classes avec useMemo en fonction des propriétés
    // Attention le premier container template n'interagfit pas avec les internal propres

    const [templateProcessId, setTemplateProcessId] = useState(
      id + "_" + template.suid
    ); //+Date.now())
    useEffect(() => {
      if (!window.templateEvents) window.templateEvents = {};
      if (!window.templateEvents[templateProcessId])
        window.templateEvents[templateProcessId] = {};

      //return ()=>{   delete window.templateEvents[templateProcessId]  }
    }, [templateProcessId]);

    const _setInternal = (key, value) => {
      console.log(id + "_setInternal _set_" + key, content["_set_" + key]);
      if (content["_set_" + key]) {
        content["_set_" + key].do(value);
        return;
      }
      if (setInternal) {
        console.log("setInternal " + id + " =  > " + key, value);
        setInternal(key, value);
        return;
      }
      console.log("setInternalContent " + id + " =  > " + key, value);
      setInternalContent((_content) => ({ ..._content, [key]: value }));
    };
    const [onValue, setOnValue] = useState();

    const _get = (key, index) => {
      if (!key && onValue) return onValue;
      if (!key && (template.schema_prop ?? template.schema_label)) {
        key = template.schema_prop ?? template.schema_label;
      }
      if (!key && template.schema_id) key = template.suid;
      if (!key) return;
      if (content["_get_" + key]) {
        var value = content["_get_" + key].do(index, content); // le content joue le role de changeur de context en profondeur : une fonction _get_Executant.do() peut rendre une liste et la fonction renvoyee par content rendre un seul Executant
        //       console.log( "no value key for _get_" +key ,{ value, stack :content["_get_" + key]})
        //console.log( id + " get_"+key, value )
        if (value) return value;
      }
      //   return content[key];
    };

    const [updateTemplate, setUpdateTemplate] = useState();
    const CustomEvents = ["onEffect", "onStart", "onValue"];

    useEffect(() => {
      if (!templateProcessId || !window.templateEvents[templateProcessId]) {
        console.log(
          "DONT EVEN EXIST jour window.templateEvents[templateProcessId]",
          { templateProcessId, templateEvents: window.templateEvents }
        );
        return;
      }
      var key = template.schema_prop ?? template.schema_label;
      if (template.schema_prop ?? template.schema_label) {
        if (
          content["_loading_" + key] &&
          (!window.dataSource || !window.dataSource["_loading_" + key])
        ) {
          if (!window.dataSource) window.dataSource = {};
          window.dataSource["_loading_" + key] = true;
          console.log("Template Loading DataSource");

          content["_loading_" + key].do(() => {
            console.log("Refresh Template " + id + " " + Date.now());
            setUpdateTemplate(Date.now());
          });

          // Charge les dataSource si besoin
        }
      }

      if (template.actions) {
        for (var ea of template.actions) {
          if (ea.Action && CustomEvents.includes(ea.Event)) {
            try {
              let var_in = {};
              var idEvent = ea.Event + "_" + ea.Action.id + "_" + template.suid;
              if (ea.Event === "onStart") {
                if (window.templateEvents[templateProcessId][idEvent]) continue;
                window.templateEvents[templateProcessId][idEvent] = true;
              } else {
                console.log("Appel Probable " + id + ea.Action.title);

                for (let key of Object.keys(ea.Action.Arguments).filter(
                  (key) => ea.Action.Arguments[key].type_put === "in"
                )) {
                  var_in[key] = _get(ea.Action.Arguments[key].value);
                  console.log(
                    ea.Action.title + " Argument Valeur " + key,
                    var_in[key]
                  );
                }

                if (
                  window.templateEvents[templateProcessId][idEvent] &&
                  (JSON.stringify(var_in) ===
                    window.templateEvents[templateProcessId][idEvent] ??
                    "")
                ) {
                  console.log(ea.Action.title + " DONT EXECUTE " + key, {
                    var_in,
                    old_var: window.templateEvents[templateProcessId][idEvent],
                  });
                  continue;
                }

                //  window.alert("sss " +JSON.stringify(var_in)   )
              }
              if (ea.Action.asynchrone)
                runAction(
                  {},
                  { ...ea.Action, self },
                  { ...content, navigate },
                  setInternal,
                  safeDisplay
                );
              else {
                
                var result = runActionSync(
                  {},
                  { ...ea.Action, self },
                  { ...content, navigate },
                  setInternal,
                  null
                  //safeDisplay
                );
               
                if (
                  typeof result === "object" &&
                  result.process === "loading"
                ) {
                  console.log(
                    "Appel Result LOADING  " + id + ea.Action.title,
                    result
                  );
                  continue;
                }

                if (ea.Event === "onValue") {
                  console.log(
                    "Appel Result ** " + id + ea.Action.title,
                    result
                  );
                  setOnValue(result ?? "onValue " + Date.now());
                }
              }
              window.templateEvents[templateProcessId][idEvent] =
                JSON.stringify(var_in);
            } catch (e) {
              console.log(ea.Action.title + " Error", e);
            }
          }
        }
      }
    }, [
      content,
      template.actions,
      _get,
      CustomEvents,
      id,
      safeDisplay,
      navigate,
      template.schema_label,
      self,
      setInternal,
      template.suid,
      template.schema_prop,
    ]);

    const _getText = (index, noNeed) => {
      var value = _get();
      if (typeof value === "object") {
        console.log(
          id + " _getText error ",

          {
            value,
            key: template.schema_prop ?? template.schema_label,
            stack:
              content["_get_" + template.schema_prop ?? template.schema_label]
                ?.stack,
          }
        );
        //value = "object"
        value =
          (template.schema_prop ?? template.schema_label) +
          " : " +
          JSON.stringify(value);
      }
      var needParams =
        !noNeed &&
        (template.schema_prop ??
          template.schema_label ??
          (content["_set_" + template.suid] && safeDisplay));
      if (template.isList && value && Array.isArray(value))
        value = value[index];
      //console.log( "_getText " +needParams,{id,value,  needParams,content }  )
      return (
        value ??
        (needParams
          ? jokerize(
              template.default_value ??
                template.text ??
                (content["_set_" + template.suid]
                  ? " - Texte " + template.suid + " -"
                  : "")
            )
          : "")
      );
    };
    const jokerizable = (text) => {
      if (!text) return text;
      const regex = /\{([^}]+)\}/gu;
      return (
        text !==
        text.replace(regex, (match, p1) => {
          return "";
        })
      );
    };

    const jokerize = (text) => {
      if (!text) return text;
      const regex = /\{([^}]+)\}/gu;
      return text.replace(regex, (match, p1) => {
        return _get(p1.trim()) ?? match;
      });
    };
    useEffect(() => {
      if (
        !template.isList &&
        !template.template_id &&
        id === selected &&
        setLocalContent
      )
        setLocalContent(content);
    }, [id, content, setLocalContent, selected]);



    function calculateChildVisibility(child,parentRect,parent) {
      const childRect = (parent ? child.parentNode : child).getBoundingClientRect();
   

      // Calculer les dimensions visibles
      const visibleHeight = Math.max(
        0,
        Math.min(childRect.bottom, parentRect.bottom) -
          Math.max(childRect.top, parentRect.top)
      );
      const visibleWidth = Math.max(
        0,
        Math.min(childRect.right, parentRect.right) -
          Math.max(childRect.left, parentRect.left)
      );
      var toptopPercentage =
        (100 * (childRect.top - parentRect.top)) / parentRect.height;
      var topPercentage =
        (100 * (childRect.bottom - parentRect.top)) / parentRect.height;
      var bottomPercentage =
        (100 * (parentRect.bottom - childRect.top)) / parentRect.height;
        var bottombottomPercentage =
        (100 * (parentRect.bottom - childRect.bottom)) / parentRect.height;
        var leftPercentage =
        (100 * (childRect.right - parentRect.left)) / parentRect.width;
      var rightPercentage =
        (100 * (parentRect.right - childRect.left)) / parentRect.width;
        var leftleftPercentage =
        (100 * (childRect.left - parentRect.left)) / parentRect.width;
      var rightrightPercentage =
        (100 * (parentRect.right - childRect.right)) / parentRect.width;

      // Aire totale de l'enfant
  

      // Aire visible (si l'élément est hors de portée, elle sera 0)
      const visibleArea =
        Math.max(0, visibleWidth) * Math.max(0, visibleHeight);

      return {
        isVisible: visibleArea > 0,
        b: Math.round(bottomPercentage),
        bb: Math.round(bottombottomPercentage),
        t: Math.round(topPercentage),
        tt:Math.round(toptopPercentage), 
        l: Math.round(leftPercentage),
        r: Math.round(rightPercentage),
        ll: Math.round(leftleftPercentage),
        rr: Math.round(rightrightPercentage),
        childRect,
        parentRect,
      };
    }


    useEffect(() => {

      var classes = [];
      var defaultclass;



    

      if (
        !content.simulatingScroll ||
        !content.simulatingScroll.id ||
        !template.className
      )
        return;
      var scrollingClasses = template.className
        .split(" ")
        .filter((c) => c.startsWith("(scrolling-"));

      if (scrollingClasses.length > 0) {
        var target = document.getElementById(id);
          if (!target) {
          console.log("pas de obj");

          return;
        }

        scrollingClasses.forEach((sc) => {
          target.classList.remove(sc);
          var parts = sc.split(")");
          var scrollingStateClass = parts[0].substr(1);
          var condition = parts.shift().replace("(scrolling-p-", "").replace("(scrolling-", "");
         
          var cls = parts.join(")").split(",");
          var partCondition = condition.split("-")
          var direction = partCondition.shift()
          condition = partCondition.join("-")
          if (condition === "default")
            defaultclass = { direction, condition, cls, scrollingStateClass };
          else
            classes.push({
              direction,
              condition: condition.split("-").map((c) => parseInt(c)),
              cls,
              scrollingStateClass,
            });
        });


     
        classes.sort((a,b)=>   a.condition>b.condition ? -1:1  )
        //  console.log(" Scrolling Change  Event "+target.id,scrollerElement)
        const result = calculateChildVisibility(target,content.simulatingScroll, defaultclass?.scrollingStateClass.startsWith("(scrolling-p-"));

        var scro = defaultclass;

        for (let sc of classes) {
          if (
            result[sc.direction] > sc.condition[0] &&
            (!sc.condition[1] ||  result[sc.direction] <= sc.condition[1])
          ) {
            scro = sc;
            break;
          }
        }

        console.log(
          `Scrolling Change:   Direction ${scro?.direction}   bottomPercentage=${ result[scro?.direction]}   ElementId= ${id}     `,
          result,
          scro,
          scrollingClasses
        );
        for (let lc of [...classes, defaultclass]) {
          if (!lc || lc.condition === scro?.condition) continue;

          target.classList.remove(...lc.cls);
          target.classList.remove(lc.scrollingStateClass);
        }
        if (scro) {
          target.classList.add(scro.scrollingStateClass);
          target.classList.add(...scro.cls);
          console.log( "setClassCss "+id + "  ", { classes:target.className,      scro,    result}  )
        }
      }
    }, [content.simulatingScroll, id, template.className]);

    useEffect(() => {
      var classes = [];
      var defaultclass;
      var classVisibility;
      var scrollerElement;

     

      function getScrollingParent(element) {
        let parent = element.parentElement;

        while (parent) {
          const isScrollable =
            parent.scrollHeight > parent.clientHeight ||
            parent.scrollWidth > parent.clientWidth;
          const hasOverflow =
            ["scroll", "auto"].includes(getComputedStyle(parent).overflowY) ||
            ["scroll", "auto"].includes(getComputedStyle(parent).overflowX);

          if (isScrollable && hasOverflow) {
            return parent; // On a trouvé un parent scrollable
          }

          parent = parent.parentElement; // Remonter d'un niveau
        }
        console.log("No Scrolling Change Parent");
        // Si aucun parent scrollable n'est trouvé, on retourne le document
        return document.documentElement;
      }
      if (!template.className) return;
      var scrollingClasses = template.className
        .split(" ")
        .filter((c) => c.startsWith("(scrolling-"));

      if (scrollingClasses.length > 0) {
        scrollingClasses.forEach((sc) => {
          var parts = sc.split(")");
          var scrollingStateClass = parts[0].substr(1);
          var condition = parts.shift().replace("(scrolling-p-", "").replace("(scrolling-", "");
         
          var cls = parts.join(")").split(",");
          var partCondition = condition.split("-")
          var direction = partCondition.shift()
          condition = partCondition.join("-")
          if (condition === "default")
            defaultclass = { direction, condition, cls, scrollingStateClass };
          else
            classes.push({
              direction,
              condition: condition.split("-").map((c) => parseInt(c)),
              cls,
              scrollingStateClass,
            });
        });

        function onScroll(target) {
          //  console.log(" Scrolling Change  Event "+target.id,scrollerElement)


          const parentRect =
          scrollerElement === window
            ? {
                top: 0,
                left: 0,
                bottom: window.innerHeight,
                right: window.innerWidth,
              }
            : scrollerElement.getBoundingClientRect();
          const result = calculateChildVisibility(target, parentRect,defaultclass?.scrollingStateClass.startsWith("(scrolling-p-"));

          var scro = defaultclass;
          for (let sc of classes) {
            if (
              result[sc.direction] > sc.condition[0] &&
              (!sc.condition[1] || result[sc.direction] <= sc.condition[1])
            ) {
              scro = sc;
              break;
            }
          }
          if (classVisibility !== scro) {
            scrollingClasses.forEach((sc) => target.classList.remove(sc));
            for (let lc of [...classes, defaultclass]) {
              if  (!lc || lc.condition === scro?.condition) continue;

              target.classList.remove(...lc.cls);
              target.classList.remove(lc.scrollingStateClass);
            }
            if (scro) {
              target.classList.add(scro.scrollingStateClass);
              target.classList.add(...scro.cls);
            //: console.log( "scrolling setClassCss "+id + "  ", { classes:target.className,      scro,    result}  )
            }

            classVisibility = scro;
          }else{
         //   console.log( "scrolling  Stay setClassCss "+id + "  ", { classes:target.className,      scro,    result}  )
          }
        }
        setTimeout(() => {
          var target = document.getElementById(id);

          if (target) {
            scrollerElement = getScrollingParent(target);
            //  scrollerElement.classList.add("bg-red-500")
            if (scrollerElement) {
              //   console.log(`Scrolling Visible: `+ id ,scrollerElement   );
              scrollerElement.addEventListener("scroll", (e) =>
                onScroll(target)
              );
              onScroll(target);
            }
          }
        }, 500);

        return () => {
          if (scrollerElement)
            scrollerElement.removeEventListener("scroll", onScroll);
        };
      }
    }, [template.className, id]);

    useEffect(() => {
      if (ref && ref.current) {
        var obj = ref.current;
        var listeners = [];
        if (template.vars) {
          template.vars.forEach((v) => {
            listeners.push({
              event: v.event,
              handler: () => {
                var result;
                eval(v.code);
                if (v.name) {
                  console.log(" UI VAR " + v.name, result);

                  setInternal(v.name, result);
                }
              },
            });
          });

          listeners.forEach((listener) =>
            obj.addEventListener(listener.event, listener.handler)
          );
        }

        return () => {
          listeners.forEach((listener) =>
            obj.removeEventListener(listener.event, listener.handler)
          );
        };
      }
    }, []);

    const background = useMemo(() => {
      if (!template.background) return;
      var name = template.background;
      var parts = template.background.split("[*");

      for (var i = 0; i < parts.length - 1; i++) {
        var nameclass = parts[i].split(".").pop();

        if (template["iBg" + nameclass]) {
          name = name.replace("*", template["iBg" + nameclass]);
        }
      }
      return name;
    }, [template]);

    const _template_className = useCallback(
      (index) => {
        var partsClasses = (template.className+"").split(" ");

        var classesOk = [];

        partsClasses.forEach((classe) => {
          if (classe.startsWith("(")) {
            var valueExpected = true;
            var iparts = classe.split(")");
            var prop = iparts.shift().substring(1);
            if (prop.startsWith("scrolling-")) return;
            if (prop.startsWith("not-")) {
              valueExpected = false;
              prop = prop.replace("not-", "");
            }
            var ifclasses = iparts.join(")");
            classe = prop;
            if (ifclasses.split(":").length === 1)
              classe += " " + ifclasses.split(",").join(" ");
var result 
         switch(prop)
         { 
case "active_link":
  if(template.schema_link)
  {
       var link =_get(template.schema_link) ?? content[template.schema_link]
     //  console.log("compare Link Active "  , { tpl:template.schema_link,   link, path : location.pathname , hash : location.hash , cpl: location.pathname +location.hash }  )
      result = (location.pathname +location.hash).endsWith(link)
  }
  
       break;
default:
  result =_get(prop)
         }
            if (valueExpected === !!result) classesOk.push(classe);
          } else classesOk.push(classe);
        });
        var _className = classesOk.join(" ");

        var result = `tpl-${tpl_id}-${template.suid} ` + _className;

        if (template.cssConditions) {
          template.cssConditions.forEach((cssCondition) => {
            var { etat, className, ajout } = cssCondition;
            var valueExpected = true;

            if (!etat) return;
            if (etat[0] === "-") {
              etat = etat.replace("-", "");
              valueExpected = false;
            }
            var parts = etat.split(":");
            var condition = false;
            if (parts.length === 2) {
              etat = parts[0].trim();
              let value = parts[1].trim();

              condition = _get(etat, index) === value;
            } else {
              var _parts = etat.split("=");
              if (_parts.length === 2) {
                etat = _parts[0].trim();
                let value = _parts[1].trim();
                if (typeof _get(value, index) === "string") {
                  console.log(
                    " cssCondition jokerize " + etat,
                    cssCondition,
                    etat,
                    jokerize(_get(value, index))
                  );
                  condition = _get(etat, index) === jokerize(_get(value));
                } else {
                  console.log(
                    " cssCondition  _get(etat) === _get(value) " + etat,
                    cssCondition,
                    etat,
                    _get(value, index)
                  );
                  condition = _get(etat, index) === _get(value, index);
                }
              } else {
                condition = _get(etat, index);
              }
            }
            //   console.log(" cssCondition "+etat, cssCondition, etat,  _get(etat,index) )
            if (!!condition === valueExpected) {
              //  console.log("CONDITION REUSSIE !!  cssCondition "+etat, cssCondition )
              // ClassName
              if (ajout) {
                result += " " + className;
              } else {
                result = className;
              }
            }
          });
        }

        if (result && palette) {
          var keysPalette = Object.keys(palette);
          result = result
            .split(" ")
            .map((classe) => {
              for (let color of keysPalette) {
                if (classe.split("-" + color).length > 1) {
                  classe = classe.split("-" + color).join("-" + palette[color]);
                  break;
                }
              }
              return classe;
            })
            .join(" ");
        }

        if (content.showHidden)
          result = ("" + result).replace(/\bhidden\b/g, "hidden_show"); //split("hidden").join("hidden_show")  //selected ===id?  "" :

        if (content.cleanResponsiveClassName) {
          var _result = content.cleanResponsiveClassName(result);

          //if(result.split(" ").join("")!== _result.split(" ").join(""))   console.log(id+  " YESSS result  cleanResponsiveClassName !! " +_result + " ////// => " + result)
          result = _result;
        }

        return result;
      },
      [
        template,
        _get,
        jokerize,
        content.showHidden,
        content.cleanResponsiveClassName,
        palette,
      ]
    );

    const isOff = useMemo(() => {
      return (_template_className() + "")?.split(" ").includes("off");
    }, [_template_className]);

    useEffect(() => {
      if (!isOff) {
        // Démarre l'animation d'apparition
        setIsAnimating(true); // Active la transition avec 'appear-start'
        setIsVisible(true); // Rend le composant visible
        setTimeout(() => setIsAnimating(false), 10); // Passe à 'appear-end' après un délai
      } else {
        // Démarre l'animation de disparition
        setIsAnimating(true); // Active la transition avec 'disappear-start'
        setTimeout(() => {
          setIsAnimating(false); // Termine l'animation avec 'disappear-end'
          setIsVisible(false); // Cache le composant après la fin de la disparition
        }, 300); // Durée totale de la transition
      }
    }, [isOff]);



    const isActive = useMemo(()=>{  

if(template?.activeProp)
{
   
   var  value  = _get(template.activeProp)
   console.log("test Activation Prop "+id + " " + template.activeProp ,   value   ,content)

   return value   
}
  else return true
    },[
_get,   template?.activeProp,content
   ])


if(!isActive && !safeDisplay)  return <></>;


    if (!isVisible && isOff) {
      return <></>;
    }

    // const {className,computedStyle } =getClassAndStyle(index)
    const getClassStyleAndDynamicsProps = (index) => {
      var className =
        (suid_path ? suid_path + "-" : "") +
        template.suid +
        " templateX " +
        (snapAlign ? " snap-align " : "") +
        _template_className(index);

      var computedStyle = {};

      if (template.mediaClasses || template.cssAttributes) {
        let mediaClasses = [];

        let jokerizables = 0;
        if (template.mediaClasses) {
          jokerizables += template.mediaClasses.filter((classe) =>
            jokerizable(classe)
          ).length;
          if (template.mediaClasses) mediaClasses = [...template.mediaClasses];
        }
        if (template.cssAttributes) {
          jokerizables += Object.keys(template.cssAttributes).filter((k) =>
            jokerizable(template.cssAttributes[k])
          ).length;
          mediaClasses = [
            ...mediaClasses,
            ...Object.keys(template.cssAttributes).map(
              (k) => k + ":" + template.cssAttributes[k]
            ),
          ];
        }
        if (jokerizables > 0 && mediaClasses.length > 0)
          setStructureCss(
            { ...template, mediaClasses },
            tpl_id,
            true,
            jokerize,

            content?.cleanResponsiveClassName
          );
      }
      if (safeDisplay) className = className.replace("fixed", "");

      if (className) {
        var classStyles = className.split(" ");
        const shortCutstyles = {
          snapContainer: { scrollSnapType: "x mandatory" },
          snapElement: { scrollSnapAlign: "center" },
        };
        const shortCutClasses = {
          horizontal: "flex flex-row",
          vertical: "flex flex-col",
          centre: " items-center justify-center",
        };
        const shortCutAttrs = { w: "width", h: "height", t: "fontSize" };
        classStyles.forEach((strclass) => {
          if (strclass.includes("=")) {
            var [attr, value] = strclass.split("=");
            attr = shortCutAttrs[attr] ?? attr;
            computedStyle[attr] = value;
          } else if (shortCutClasses[strclass])
            className += " " + shortCutClasses[strclass];
          else if (shortCutstyles[strclass])
            computedStyle = { ...computedStyle, ...shortCutstyles[strclass] };
        });
      }

      var dynamicsProps = {};

      if (template.attrDatas) {
        Object.keys(template.attrDatas).forEach((key) => {
          if (template.attrDatas[key].type === "schema_labelData") {
            dynamicsProps[key] =
              _get(template.attrDatas[key].value, index) ?? "";
          } else if (template.attrDatas[key].type === "eventHandlerData") {
            dynamicsProps[key] = (e) => {
              try {
                eval(template.attrDatas[key].value);
              } catch (e) {
                console.log("Error", e);
              }
            };
          } else if (template.attrDatas[key].type === "expressionData") {
            var result = null;
            try {
              let { self } = content;
              eval("result=" + template.attrDatas[key].value);
            } catch (e) {
              console.log("Error", e);
            }
            dynamicsProps[key] = result;
          } else if (template.attrDatas[key].type === "computeData") {
            var result = null;
            try {
              eval(template.attrDatas[key].value);
            } catch (e) {
              console.log("Error");
            }
            dynamicsProps[key] = result;
          } else dynamicsProps[key] = jokerize(template.attrDatas[key].value);

          var parts = key.split(".");
          if (parts.length > 1 && parts[0] === "style") {
            computedStyle[parts[1]] = dynamicsProps[key];
            delete dynamicsProps[key];
          }
        });
      }

      if (content?.dynamicsProps) {
        dynamicsProps = { ...dynamicsProps, ...content.dynamicsProps };
        //delete content.dynamicsProps
      }

      if (
        CustomTag === "img" &&
        (!("src" in dynamicsProps) || !dynamicsProps["src"])
      )
        dynamicsProps["src"] =
          _get() ??
          template.default_value ??
          template.imageUrl ??
          (safeDisplay
            ? process.env.REACT_APP_MFTC_SERVER_URL_FILES + "medias/user.png"
            : null);
      if (CustomTag === "img" && !("alt" in dynamicsProps))
        dynamicsProps["alt"] = "imgXXX";
      if (CustomTag === "img" && className.split("object-").length === 1)
        className += " object-cover";

      if (template.backgroundImage || template.backgroundImageDefault) {
        var imgsrc = template.backgroundImageDefault;
        if (template.backgroundImage) {
          var v = _get(template.backgroundImage);
          if (v) imgsrc = v;

          if (imgsrc) {
            computedStyle.backgroundImage = `url(${imgsrc})`;
          }
        }
      }

      return { className, computedStyle, dynamicsProps };
    };

    var schema =
      schemas && template.schema_id
        ? schemas.find((c) => c.content_id + "" === "" + template.schema_id)
        : null;

    const TriggerAction = async (event, e) => {
      if (template.actions) {
        for (var ea of template.actions) {
          if (ea.Action && ea.Event === event) {
            try {
              if (ea.Action.asyncrhone)
                await runAction(
                  e,
                  { ...ea.Action, self },
                  { ...content, navigate },
                  setInternal,
                  safeDisplay
                );
              else
                runActionSync(
                  e,
                  { ...ea.Action, self },
                  { ...content, navigate },
                  setInternal,
                  safeDisplay
                );
            } catch (e) {
              console.log("Error", e);
            }
          }
        }
      }
    };

    const hasEventAction = (event) => {
      if (
        event === "onClick" &&
        (template.onClick ||
          template.Link ||
          template.schema_link ||
          template.schema_url)
      )
        return true;
      return (
        template.actions &&
        template.actions.find((ea) => ea.Action && ea.Event === event)
      );
    };

    // Click Sur l'élément
    var onClick = async (e, childEvent, safe) => {
      console.log("*********  Click", id, template, content);
      if (!id) return;
      if (!childEvent) {
        if (selectTpl && typeof selectTpl === "function") {
          var _id = id
            .split(".")
            .map((c) => c.split(":")[0])
            .join(".");

          e.stopPropagation();
          if (selectTpl(_id, template) === "stop") return;
        }
      }

      if (parentClick) parentClick(e);

      await TriggerAction("onClick", e);

      if (!content) return;
      if (
        template.popupTemplate &&
        template.onClick?.split("Popup:").length > 1
      ) {
        if (safeDisplay && typeof safeDisplay === "function" && !safe)
          return safeDisplay(" Voulez-vous ouvrir le popup  ? ", () =>
            onClick(e, childEvent, true)
          );

        var popup_id = template.onClick
          ?.replace("Popup:", "")
          .replace("<", "")
          .replace(">", "");

        if (popup_id === "Self")
          setPopupTemplate({
            template_id: parseInt(template.popupTemplate),
            content: content,
          });
        if (true || content[popup_id])
          setPopupTemplate({
            template_id: parseInt(template.popupTemplate),
            popup_id,
            content: content[popup_id]?.content,
          });
      }

      var link = template.Link;
      if (link) {
        console.log("Clicking Link", link, content);
      }
      if (link && content[link]) {
        if (safeDisplay && typeof safeDisplay === "function" && !safe)
          return safeDisplay(" Voulez-vous ouvrir le lien  ? ", () =>
            onClick(e, childEvent, true)
          );

        navigate(
          (process.env.REACT_APP_ENV === "dev" || getApp() === "pro" //process.env.REACT_APP_MFTC_APP!=="client"
            ? "/domain/" + content.domain
            : "") + content[link]
        );
      }
      if (template.schema_url) {

       var url =_get(template.schema_url) ?? content[template.schema_url]
if(url)
{        if (safeDisplay && typeof safeDisplay === "function" && !safe)
          return safeDisplay(" Voulez-vous ouvrir le lien  ? ", () =>
            onClick(e, childEvent, true)
          );
       
        window.open(url, "_blank");
        return
        }
      }
      if (template.schema_link ) {
        var dyn_link =_get(template.schema_link) ?? content[template.schema_link]
        if(dyn_link)
        {      



        if (dyn_link[0] === "#") {
          if (safeDisplay && typeof safeDisplay === "function" && !safe)
            return safeDisplay(" Voulez-vous aller sur l'ancrage  ? ", () =>
              onClick(e, childEvent, true)
            );
          var obj = document.querySelector(content[template.schema_link]);
          if (obj) {
            console.log("scroll by Onclick  ", obj.id, obj);
            obj.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
          }
        } else {
          if (safeDisplay && typeof safeDisplay === "function" && !safe)
            return safeDisplay(" Voulez-vous ouvrir le lien  ? ", () =>
              onClick(e, childEvent, true)
            );
         

          if (content["content_id"])
            dyn_link = dyn_link.replace(":id", content["content_id"]);
         if(navigate)  navigate(
            (process.env.REACT_APP_ENV === "dev" || getApp() === "pro"
              ? "/domain/" + content.domain
              : "") + dyn_link
          );
        }
      }
      else
      {
        console.log({  error :template.schema_link  ,    schema_linkContentError: content,id} )
    //    window.alert(template.schema_link + _get(template.schema_link))

      }
      }

      var action = template.onClick;
      if (action) {
        if (safeDisplay && typeof safeDisplay === "function" && !safe)
          return safeDisplay(" Voulez-vous démarrer l'action ? ", () =>
            onClick(e, childEvent, true)
          );
        let _content;
        switch (action) {
          case "CONTENT_CREATE":
          case "CONTENT_UPDATE":
          case "CONTENT_SET":
            //console.log("InternalContent ********* " , _internalContent);
            _content = RecomposeContent(content);
            //window.alert(JSON.stringify(_content))
            if (_content && !(_content.content_id + "").includes("test"))
              data.save_content(_content).then(() => {
                navigate(-1);
              });

            return;

          case "CONTENT_DELETE":
            _content = RecomposeContent(content);
            if (_content && _content.content_id) {
              showModal(
                "Are you sure you want to delete  content n°" +
                  _content.content_id +
                  "?",
                {
                  key: "confirm",
                  Content: (
                    <div className="flex gap-2 items-center justify-center  ">
                      <div
                        className=" p-2 bg-red-500 text-white "
                        onClick={() => {
                          closeModal("confirm");
                        }}
                      >
                        {" "}
                        Annuler{" "}
                      </div>
                      <div
                        className=" p-2 bg-green-500 text-white "
                        onClick={() => {
                          data.delete_content(_content.content_id).then(() => {
                            navigate(-1);
                          });

                          closeModal("confirm");
                        }}
                      >
                        {" "}
                        Confirmer{" "}
                      </div>
                    </div>
                  ),
                }
              );
            }

            return;
          default:
        }
        if (action.includes("SwitchInternal_")) {
          var i = action.split("_")[1];
          console.log("_Internal_" + i + " = " + !content["_Internal_" + i]);
          setInternal("_Internal_" + i, !content["_Internal_" + i]);

          return true;
        }

        if (content[action]) {
          if (safeDisplay && typeof safeDisplay === "function" && !safe)
            return safeDisplay(" Voulez-vous démarrer l'action  ? ", () =>
              onClick(e, childEvent, true)
            );
          console.log("Il y a de l'action " + action);
          if (typeof content[action] === "string") eval(content[action]);
          else {
            console.log("Execution de l'action " + action);
            content[action]();
          }
        }
      }

      return true;
    };




    var templateValue = _get();

    var _listElements = [];

    if (template.isList) {
      if (templateValue) {
        if (!Array.isArray(templateValue)) templateValue = [templateValue];

        _listElements = [];
        templateValue.forEach((value, i) => {
          if (!value || !value.is_query)
            _listElements.push(
              typeof value === "object"
                ? { ...value, index: _listElements.length }
                : value
            );

          //  return typeof value === "object" ? { ...(value), index: i } : value;
        });

        //   console.log("List Elements =", { _listElements });
      } else {
        /*  console.log(
        template.listLength + " elements",
        typeof template.listLength
      );*/
        var n = template.listLength ? parseInt(template.listLength) : 1;

        _listElements = Array(n)
          .fill({})
          .map((c, i) => {
            return { ...c, index: i };
          });
        _listElements = Array(n).fill(null);
        //   console.log(n, _listElements);
      }
    } else {
      if (templateValue && typeof templateValue === "object") {
        _listElements = [templateValue];
      } else {
        _listElements = [templateValue];
      }
    }

    //  _listElements  =_listElements.filter((value)=> (!value || typeof value !== "object" || !value.is_query) )
    //const [ listElements,setListElements]=useState(_listElements)
    var listElements = _listElements;

    if (transitionState === "Unknown") return <></>;
    if (transitionState === "Hidden") return <></>;








    if (template.template_id) {
      //Fonctionne avec schema
      // return <div> No templates loaded</div>
      if (!templates) return <div> No templates loaded</div>;

      var tpl =
        template.template ??
        templates.find((t) => t.template_id + "" === "" + template.template_id);

      if (!tpl) return <div>Template {template.template_id} Not Found</div>;
      const isList = template.isList && !tpl.is_list;

      if (!isList && template.isList) {
        console.log("isList NONONONOlIST", listElements);

        listElements = [listElements];
      }
      //  console.log("xxxxxxxx TEMPLATE lIST " + template.schema_prop, listElements)
      //console.log(id + " Loading Sub Template " + tpl.title ,{ template,listElements} )
      var schema_key = template.schema_prop ?? template.schema_label;
      var getFunction = content["_get_" + schema_key] ?? {
        do: () => {},
        stack: ["No get Func"],
      };
      var setFunction = content["_set_" + schema_key] ?? {
        do: () => {},
        stack: ["No set Func"],
      };
      var suid_getters = {};
      Object.keys(content)
        .filter((k) => k.startsWith("_get_" + template.suid + "-"))
        .forEach((key) => {
          suid_getters[key.split(template.suid + "-").join("")] = content[key];
        });
      Object.keys(content)
        .filter((k) => k.startsWith("_set_" + template.suid + "-"))
        .forEach((key) => {
          suid_getters[key.split(template.suid + "-").join("")] = content[key];
        });

      var structure = { ...tpl.structure };
      var meta_tpl = {};
      if (template.is_meta) {
        structure = metaStructureMapping(structure, template);

        console.log("meta_structure " + schema_key, {
          template,
          structure,
          getFunction,
          setFunction,
        });

        meta_tpl.template_id = tpl.template_id + "-" + template.suid;
        meta_tpl.schema_id = template.schema_id;
      }

      window.structure[id + "-tpl"] = template;

      return listElements.map((element, index) => {
        const { className, computedStyle, dynamicsProps } =
          getClassStyleAndDynamicsProps(isList ? index : null);

        var GetElement = {
          do: () => {
            if (isList) {
              return getFunction.do(isList ? index : null);
            } else {
              if (true || schema_key === "title") {
                //   console.log( id +" GetElement " +   schema_key ,{schema_key,getFunction ,value:  getFunction.do()})
              }
              var value = getFunction.do();
              //  console.log("GetElement ",{ prop : template.schema_prop,label :   template.schema_label,value  }    )
              return value;
            }
          },
          stack: [
            ...getFunction.stack,
            id + " GetElement " + (isList ? index : ""),
          ],
        };

        var SetElement = {
          do: async (value) => {
            if (isList) {
              await setFunction.do(value, index);
            } else {
              await setFunction.do(value);
            }
          },
          stack: [...setFunction?.stack, id + " SetElement "],
        };

        //  console.log(" GetElement preparation",{ prop : template.schema_prop,label :   template.schema_label  }    )

        var TemplateG = _components[element?.content?._component] ?? TemplateX;
        var _id = id + (index > 0 && isList ? ":" + index : "");
        var BF = {};
        if (element && typeof element === "object") {
          BF = element;
        }
        element = FlatObject(element);
        if (element && typeof element === "object") {
          element.BFElement = BF;
        }

        return (
          <>
            <TemplateG
              template={{
                ...structure,
                className: (
                  (structure.className ?? "") +
                  " " +
                  (className ?? "")
                ).trim(),
              }}
              internals={internals}
              setInternal={_setInternal}
              content={{
                ...content,

                ...(typeof element === "object" ? element : {}),
                ...(element?.content ? element.content : {}),
                ...(_internalContent ?? internalContent),
                self: element,
                selfName: template.schema_label ?? self, // tschema_prop ?? template.schema_label ?? self,
                ...(content?.GetSetTers
                  ? content?.GetSetTers(
                      { ...tpl, ...meta_tpl },
                      GetElement,
                      SetElement,
                      { setInternal, self: "self", content, element_id: id }
                    )
                  : {}),
                ...suid_getters,
                dynamicsProps: dynamicsProps,
              }}
              palette={palette}
              self={template.schema_label ?? self} //{tschema_prop ?? template.schema_label ?? self}
              _internalContent={_internalContent ?? internalContent}
              safeDisplay={safeDisplay}
              templates={templates}
              schemas={schemas}
              contents={contents}
              navigate={navigate}
              selectTpl={
                selectTpl
                /*   typeof selectTpl === "function"
                ? (...args) => {
                    if (document.getElementById(id + "-edited"))
                      selectTpl(...args);
                    else selectTpl(id);
                  }
                : () => {}*/
              }
              id={_id}
              key={_id}
              selected={selected}
              schema_prop={template.schema_prop ?? schema_prop}
              parentClick={
                parentClick ??
                (hasEventAction("onClick") ? (e) => onClick(e, true) : null)
              }
              snapAlign={snapAlign}
              setLocalContent={setLocalContent}
              suid_path={(suid_path ? suid_path + "-" : "") + template.suid}
              tpl_id={tpl.template_id}
            />
          </>
        );
      });
    }

    const PopupTemplate = () => {
      //creer une animation css
      const [style, setStyle] = useState(" opacity-0 scale-0 ");
      const [hide, setHide] = useState(false);
      //creer une animation

      useEffect(() => {
        if (popupTemplate)
          setTimeout(() => {
            setStyle("opacity-100 scale-100 ");
            const scrollY =
              document.documentElement.style.getPropertyValue("--scroll-y");
            const body = document.body;
            body.style.position = "fixed";
            body.style.top = `-${scrollY}`;
          }, 20);
      }, []);

      useEffect(() => {
        if (hide) {
          const body = document.body;
          const scrollY = body.style.top;
          body.style.position = "";
          body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
          setStyle("opacity-0  scale-0");
          setTimeout(() => setPopupTemplate(), 200);
        }
      }, [hide]);

      if (!popupTemplate) return <></>;

      console.log("popuptemplate", popupTemplate, content);
      return (
        <div
          className={
            "  transition-all  duration-200 fixed z-50  top-0 left-0 w-screen h-screen bg-black bg-opacity-40 flex flex-row items-center justify-center " +
            style
          }
        >
          <TemplateX
            internals={internals}
            templates={templates}
            template={
              templates.find((t) => t.template_id === popupTemplate.template_id)
                .structure
            }
            palette={palette}
            self={template.schema_label ?? self} //{tschema_prop ?? template.schema_label ?? self}
            schemas={schemas}
            contents={contents}
            content={popupTemplate.content}
            snapAlign={snapAlign}
            navigate={navigate}
            tpl_id={popupTemplate.template_id}
            suid_path={suid_path}
          />
          <div className="top-0 left-0 absolute safearea w-full h-40  flex flex-row justify-start ">
            <Icon
              icon={fa.faArrowLeft}
              className="m-4 w-4 h-4 p-2 bg-white rounded-full text-black shadow"
              onClick={() => setHide(true)}
            />
          </div>
        </div>
      );
    };

    if (template.tag === "icon" || template.schema_id === 48) {
      return listElements.map((element, index) => {
        const { className, computedStyle, dynamicsProps } =
          getClassStyleAndDynamicsProps(template.isList ? index : null);

        var _id = id + (template.isList && index > 0 ? ":" + index : "");
        var iconValue = element ?? template.default_value ?? template.icon;
        return (
          <Icon
            key={_id}
            ref={ref}
            id={_id}
            icon={
              iconValue &&
              iconValue.startsWith &&
              (iconValue.startsWith("svg:") || iconValue.startsWith("svga:"))
                ? iconValue
                : fa[iconValue ?? "faQuestion"]
            }
            className={className + "   "}
            style={computedStyle}
            onClick={onClick}
          />
        );
      });
    }

    if (template.tag === "svg" || template.schema_id === 63 ) {
      return listElements.map((element, index) => {
        const { className, computedStyle, dynamicsProps } =
          getClassStyleAndDynamicsProps(template.isList ? index : null);

        var _id = id + (template.isList && index > 0 ? ":" + index : "");
        var svgValue = element;

        return (
          <Svg
            key={_id}
            ref={ref}
            id={_id}
          
            content={svgValue }
            className={className + "   "}
            style={computedStyle}
            onClick={onClick}
          />
        );
       
        return (


                  <svg
            key={_id}
            ref={ref}
            id={_id}
            className={" svg-inline--fa  inline-block  " +className}
          
          
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox={
              svgValue?.viewBox ?? "0 0 512 512"
            }
            style={computedStyle}
            onClick={onClick}
            dangerouslySetInnerHTML={{ __html: svgValue?.content.path }}
          >
          </svg>
        );
      });
    }

    if (template.tag === "input") {
      return listElements.map((element, index) => {
        var _id = id + (template.isList && index > 0 ? ":" + index : "");
        const { className, computedStyle, dynamicsProps } =
          getClassStyleAndDynamicsProps(template.isList ? index : null);
        return (
          <TemplateInput
            template={template}
            key={_id}
            self={self}
            id={_id}
            palette={palette}
            element={element}
            className={className + "   "}
            style={computedStyle}
            onClick={onClick}
            internals={internals}
            setInternal={_setInternal}
            content={{
              ...content,

              ...(element?.content ??
                (typeof element === "object" ? element : {})),

              ...(_internalContent ?? internalContent),
            }}
            _internalContent={_internalContent ?? internalContent}
            templates={templates}
            schemas={schemas}
            contents={contents}
            domain={content.domain}
            selectTpl={selectTpl}
            selected={selected}
            safeDisplay={safeDisplay}
            parentClick={
              parentClick ??
              (hasEventAction("onClick") ? (e) => onClick(e, true) : null)
            }
            schema_prop={template.schema_prop ?? schema_prop}
          />
        );
      });
    }

    if (template.tag === "map" || template.schema_id === 107) {
      const { className, computedStyle, dynamicsProps } =
        getClassStyleAndDynamicsProps();

      return (
        <>
          <MapContent
            id={id}
            ref={ref}
            map={_get()}
            style={computedStyle}
            className={className + "   "}
            onClick={onClick}
          />
        </>
      );
    }

    var CustomTag = template.tag === "text" ? "div" : template.tag ?? "div";
    if (template.tagName === "FontAwesomeIcon") CustomTag = FontAwesomeIcon;
    else if (template.tagName) CustomTag = template.tagName;

    if (!content.setContent)
      content.setContent = (key, value) => setInternal(key, value);
    if (!content.getContent) content.getContent = (key) => content[key] ?? null;

    return listElements.map((element, index) => {
      var _id = id + (template.isList && index > 0 ? ":" + index : "");

      // element = FlatObject(element);

      let _content = { ...content };
      if (template.isList) {
        // Une liste d'element non template
        // Une structure qui se repete sans template
        var key = template.schema_prop ?? template.schema_label;
        if (key) {
          if (content["_get_" + key])
            _content["_get_" + key] = {
              ...content["_get_" + key],
              do: () => content["_get_" + key].do(index),
            };

          if (content["_set_" + key])
            _content["_set_" + key] = {
              ...content["_set_" + key],
              do: (value) => content["_set_" + key].do(value, index),
            };

          if (content["_post_" + key])
            _content["_post_" + key] = {
              ...content["_post_" + key],
              do: (value) => content["_post_" + key].do(value, index),
            };
          //  if (content[key]) _content = { ...content, [key]: content[key][index] };
          // if(content["_set_" + key]) _content["_set_" + key] =(value)=> content["_set_" + key](value,index)
          //   if(content["_get_" + key]) _content["_get_" + key] =(value)=> content["_get_" + key](value,index)
        }

        return (
          <TemplateX
            template={{ ...template, isList: false }}
            internals={internals}
            palette={palette}
            setInternal={_setInternal}
            content={{
              ..._content,

              //   ...(element?.content ??           (typeof element === "object" ? element : {})),
              ...(_internalContent ?? internalContent),
              ["index_" + key]: index,
            }}
            self={self}
            _internalContent={_internalContent ?? internalContent}
            templates={templates}
            schemas={schemas}
            contents={contents}
            navigate={navigate}
            key={_id}
            id={_id}
            selectTpl={selectTpl}
            selected={selected}
            safeDisplay={safeDisplay}
            parentClick={
              parentClick ??
              (hasEventAction("onClick") ? (e) => onClick(e, true) : null)
            }
            schema_prop={schema_prop}
            setLocalContent={setLocalContent}
            suid_path={suid_path}
            tpl_id={tpl_id}
          />
        );
      }

      const { className, computedStyle, dynamicsProps } =
        getClassStyleAndDynamicsProps(template.isList ? index : null);

      const isContentEditable = false &&
        safeDisplay &&
        (template.tag === "text" ||
          template.schema_id === 42 ||
          template.schema_id === 43 ||
          template.schema_id === 49 ||
          template.schema_id === 44) &&
        (!template.children || template.children.length === 0) &&
        content["_set_" + template.suid];
      var onFocus;
      var onInput;
      var onBlur;
      if (isContentEditable) {
        onFocus = (e) => {
          if (selectTpl) selectTpl(id);
          var realText = _getText(index, true);
          console.log({
            onFocus: template.suid + " " + realText,
            target: e.target,
          });
          if (!realText) e.target.innerText = "";
        };
        onInput = (e) => {
          console.log(e.target.innerText);
        };
        onBlur = (e) => {
          var value = e.target.innerText.trim();
          if (value === "") value = null;
          if (_getText(index, true) === value) return;
          console.log(content["_set_" + template.suid]);
          console.log({ onBlur: value, target: e.target });
          console.log(e.target.innerHTML);
          content["_set_" + template.suid].do(value);
          if (!value) e.target.innerText = _getText(index);
        };
      }

      if (template.actions) {
        template.actions
          .filter((ea) => !CustomEvents.includes(ea.Event))
          .forEach((ea) => {
            //    window.alert("Actions " +ea.Event)
            dynamicsProps[ea.Event] = async (e) => {
              try {
                if (ea.Action.asyncrhone)
                  await runAction(
                    e,
                    { ...ea.Action, self },
                    { ..._content, navigate },
                    setInternal
                  );
                else
                  runActionSync(
                    e,
                    { ...ea.Action, self },
                    { ..._content, navigate },
                    setInternal
                  );
              } catch (e) {
                console.log("Error");
              }
            };
          });
      }
      if (
        CustomTag === "img" ||
        CustomTag === "input" ||
        CustomTag === "textarea"
      ) {
        if (dynamicsProps) {
          var value =
            (template.tag === "text" ||
              template.schema_id === 42 ||
              template.schema_id === 239 ||
              template.schema_id === 43 ||
              template.schema_id === 49 ||
              template.schema_id === 44) &&
            _getText(index);

          if (value) dynamicsProps[value] = value;
        }

        return (
          <CustomTag
            ref={ref}
            key={index}
            type={template.type}
            id={
              (label
                ? label + (template.isList && index > 0 ? ":" + index : "")
                : null) ?? _id
            }
            className={className + "  "}
            style={{
              ...computedStyle,
            }}
            onClick={onClick}
            {...dynamicsProps}
          />
        );
      }

      return (
        <>
          <CustomTag
            ref={ref}
            key={id + "x" + index}
            id={
              (label
                ? label + (template.isList && index > 0 ? ":" + index : "")
                : null) ?? _id
            }
            className={className + " "}
            style={{
              ...computedStyle,

              ...(background
                ? {
                    backgroundImage: content[background]
                      ? `url(${content[background]})`
                      : `url(https://placehold.co/400x100/${Math.round(
                          1000000 * Math.random()
                        )}/DDDDDD/png?text=${background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }
                : {}),
            }}
            {...dynamicsProps}
            onClick={onClick}
            contentEditable={isContentEditable ? "true" : null}
            //   suppressContentEditableWarning
            onInput={onInput} // Capture les changements en temps réel
            onBlur={onBlur}
            onFocus={onFocus}
          >
            {(template.tag === "text" ||
              template.schema_id === 42 ||
              template.schema_id === 239 ||
              template.schema_id === 43 ||
              template.schema_id === 49 ||
              template.schema_id === 44) &&
              _getText(index)}

            {"children" in template &&
              template.children.map((tpl, i) => (
                <TemplateX
                  template={tpl}
                  tpl_id={tpl_id}
                  internals={internals}
                  palette={palette}
                  setInternal={_setInternal}
                  content={{
                    ..._content,

                    ...(element?.content ??
                      (typeof element === "object" ? element : {})),
                    ...(_internalContent ?? internalContent),
                    selfMap:
                      template.schema_prop ?? template.schema_label ?? self,
                  }}
                  self={template.schema_prop ?? template.schema_label ?? self}
                  _internalContent={_internalContent ?? internalContent}
                  key={_id && _id + "." + i}
                  templates={templates}
                  schemas={schemas}
                  contents={contents}
                  navigate={navigate}
                  id={_id && _id + "." + i}
                  selectTpl={selectTpl}
                  selected={selected}
                  safeDisplay={safeDisplay}
                  parentClick={
                    parentClick ??
                    (hasEventAction("onClick") ? (e) => onClick(e, true) : null)
                  }
                  schema_prop={template.schema_prop ?? schema_prop}
                  setLocalContent={setLocalContent}
                  suid_path={suid_path}
                />
              ))}
          </CustomTag>
          <PopupTemplate />
        </>
      );
    });

    //else
    //return <span >{endpoint} </span>
  }
);

export default TemplateX;
